var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const EMPTY_ARRAY = [];
class PlayerEventManager {
  constructor() {
    __publicField(this, "queue", []);
  }
  getLastQueue() {
    return [this.queue[this.queue.length - 1], this.queue.length];
  }
  addEvent(event) {
    this.queue.push(event);
  }
  getEvents() {
    if (Object.keys(this.queue).length === 0) {
      return EMPTY_ARRAY;
    }
    const changes = this.queue;
    this.queue = [];
    return changes;
  }
}
export {
  PlayerEventManager
};
//# sourceMappingURL=PlayerEventManager.js.map
